import { TEST_CLICK} from './actions'

export function testClicked(state=[],action) {
  switch(action.type) {
    case TEST_CLICK:
      return action.par
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/test/reducers.js